import React, { useCallback, useState } from 'react';
import { v4 as uuid } from 'uuid';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

import {
  Name,
  Email,
  CheckInCheckOut,
  Phone,
  Adults,
  Rooms,
  Staff,
  Notes,
  Children,
} from '../components/form/Inputs';

import './Form.css';

export const Form: React.FC<any> = ({
  isOpen,
  setIsOpen,
  onAddToWaitlist,
  values,
}) => {
  const [checkin, setCheckin] = useState<Date | null>(null);
  const [checkout, setCheckout] = useState<Date | null>(null);
  const [adults, setAdults] = useState<number>(values?.adults);
  const [children, setChildren] = useState<number>(values?.children);
  const [rooms, setRooms] = useState<number>(values?.rooms);

  const handleAddToWaitlist = useCallback(
    async (e: any) => {
      e.preventDefault();
      e.stopPropagation();

      const form = new FormData(e.target);
      // TODO: validation

      const payload = {
        id: uuid(),
        name: form.get('name'),
        phone: form.get('phone'),
        email: form.get('email'),
        adults,
        children,
        rooms,
        checkin,
        checkout,
        staff: form.get('staff'),
        notes: form.get('notes'),
      };

      await onAddToWaitlist(payload);
      setIsOpen(false);
    },
    [onAddToWaitlist, checkin, checkout, adults, children, rooms]
  );

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle>Add to Waitlist</DialogTitle>
      <form onSubmit={handleAddToWaitlist}>
        <DialogContent>
          <Name />
          <Phone />
          <Email />
          <div>
            <CheckInCheckOut
              setCheckin={setCheckin}
              checkin={checkin}
              setCheckout={setCheckout}
              checkout={checkout}
            />
          </div>
          <Adults adults={adults} setAdults={setAdults} />
          <Rooms rooms={rooms} setRooms={setRooms} />
          <Children children={children} setChildren={setChildren} />
          <Staff />
          <Notes />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>Cancel</Button>
          <Button type="submit" variant="contained">
            Add to Waitlist
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
